import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 25,
		cy: 25,
		r: 24.5,
		fill: "white",
		stroke: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.1868 18.1549C13.0669 18.4116 13 18.698 13 19V31.2393C13 32.3439 13.8954 33.2393 15 33.2393H35C36.1046 33.2393 37 32.3439 37 31.2393V19C37 18.6962 36.9323 18.4083 36.8111 18.1504L26.4528 25.5509C25.5837 26.1718 24.4161 26.172 23.5468 25.5514L13.1868 18.1549ZM13.8247 17.3816L24.1279 24.7375C24.6495 25.1099 25.35 25.1098 25.8715 24.7372L36.1712 17.3786C35.842 17.1404 35.4374 17 35 17H15C14.5608 17 14.1547 17.1416 13.8247 17.3816Z",
		fill: "black"
	})]
});
export default SvgReferralMail;
